export enum RemoteConfigParameter {
    CreatePdfReportButtonVisible = 'createPdfReportButtonVisible',
    CountryDropdownByCountry = 'countryDropdownByCountry',
    CountryLanguageSwitcherByCountry = 'countryLanguageSwitcherByCountry',
    QuoteAssistByCountry = 'quoteAssistByCountry',
    PartnerShopByCountry = 'partnerShopByCountry',
    PdfConfiguratorBySection = 'pdfConfiguratorBySection',
    DeviceCalculationByCountry = 'deviceCalculationByCountry',
    DeviceCalculationByRole = 'deviceCalculationByRole',
    PdfConfiguratorGeneralInformationBySubsection = 'pdfConfiguratorGeneralInformationBySubsection',
    PdfConfiguratorHeatPumpPlanBySubsection = 'pdfConfiguratorHeatPumpPlanBySubsection',
    PdfConfiguratorPhotovoltaicPlanBySubsection = 'pdfConfiguratorPhotovoltaicPlanBySubsection',
    PdfConfiguratorVentilationPlanBySubsection = 'pdfConfiguratorVentilationPlanBySubsection',
    PdfConfiguratorFullSystemBySubsection = 'pdfConfiguratorFullSystemBySubsection',
    PdfConfiguratorLegalNoticeBySubsection = 'pdfConfiguratorLegalNoticeBySubsection',
    PdfConfiguratorPitchDeckByLocale = 'pdfConfiguratorPitchDeckByLocale',
    PdfConfiguratorDocumentationTabVisible = 'pdfConfiguratorDocumentationTabVisible',
    DomesticElectricityDayNightTariffByCountry = 'domesticElectricityDayNightTariffByCountry',
    HeatPumpElectricityFlatRateByCountry = 'heatPumpElectricityFlatRateByCountry',
    HeatPumpElectricityDayNightTariffByCountry = 'heatPumpElectricityDayNightTariffByCountry',
    HeatPumpElectricityBlockTimeByCountry = 'heatPumpElectricityBlockTimeByCountry',
    HeatPumpElectricityBlockTimeDisabledByCountry = 'heatPumpElectricityBlockTimeDisabledByCountry',
    OnboardingVersion = 'onboardingVersion',
    BoilerPlannerAvailable = 'boilerPlannerAvailable',
    IncludeArchivedProjects = 'includeArchivedProjects',
    MaintenanceAllowedRoles = 'maintenanceAllowedRoles',
    IsVitoAirAvailable = 'isVitoAirAvailable',
    BasicProfitabilityByCountry = 'basicProfitabilityByCountry',
    IsProfitabilityAvailable = 'isProfitabilityAvailable',
    VitoAirAvailableByLocale = 'vitoAirAvailableByLocale',
    HasUserVariantOptions = 'hasUserVariantOptions',
    HasUserVariantPlanningOptions = 'hasUserVariantPlanningOptions',
    IsPitchDeckAvailableForAllVariants = 'isPitchDeckAvailableForAllVariants',
    IsWelcomeBannerAvailable = 'isWelcomeBannerAvailable'
}
